import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = o((l, s) => /* @__PURE__ */ c.jsx(
  t,
  {
    ref: s,
    ...l,
    image: (a) => /* @__PURE__ */ c.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: [
          /* @__PURE__ */ c.jsx(
            "path",
            {
              fill: "#1D1D42",
              d: "M41.051 23.006c-.487-.275-1.049-.238-1.523-.113 0-.125.025-.25.025-.362.686-9.14-2.773-15.284-9.74-17.294-.475-.138-.974-.25-1.486-.35l-.45-.075-.15-.025c-.4-.062-.811-.125-1.248-.162a8 8 0 0 0-.575-.05c-1.224-.1-2.597-.1-3.833 0-.187.012-.375.037-.575.05-.424.05-.836.1-1.236.162l-.15.025-.45.075c-.511.1-1.01.212-1.485.35C11.22 7.247 7.76 13.378 8.447 22.53c0 .125.025.25.025.362-.474-.125-1.036-.162-1.523.113-.637.35-.949 1.086-.949 2.185.012 2.922 2.535 4.745 4.42 5.182 1.661 3.596 4.283 6.43 7.43 8.067l.35.2c.1.05.187.087.287.124l.287.125c.138.063.275.125.412.175.5.2.95.35 1.374.462.337.6 1.186 1.623 1.66 2.06.05.05.1.088.188.15.512.437 1.049.65 1.56.65h.05q.807 0 1.612-.675c.05-.037.1-.075.15-.125.474-.424 1.323-1.46 1.66-2.06.425-.112.874-.262 1.361-.462.138-.05.275-.112.425-.175l.287-.125c.1-.037.2-.075.287-.125l.35-.187c3.147-1.636 5.769-4.483 7.43-8.066 1.885-.437 4.407-2.26 4.42-5.183 0-1.098-.312-1.835-.949-2.185zM7.249 25.178c0-.574.112-.974.312-1.086.287-.162.949.088 1.323.325l.225.137c.3 1.66.75 3.16 1.274 4.495-1.261-.412-3.11-1.648-3.122-3.87zm22.014 12.313-.2.112h-.024l-.313.137c-.124.05-.25.113-.374.163-.487.187-.9.337-1.299.437-.3.075-.537.262-.674.524-.2.4-1.012 1.399-1.436 1.786l-.15.125c-.287.237-.537.362-.787.362h-.012c-.238 0-.487-.112-.787-.362l-.137-.113c-.425-.387-1.236-1.386-1.436-1.785a1.03 1.03 0 0 0-.675-.525c-.4-.1-.811-.25-1.298-.437-.125-.05-.25-.1-.375-.162l-.537-.25c-1.623-.787-3.109-1.935-4.383-3.346-.075-1.511.625-3.41 1.773-3.971 2.123-1.024 5.282 2.16 7.867 2.16s5.744-3.184 7.867-2.16c1.161.55 1.848 2.447 1.773 3.97-1.273 1.424-2.76 2.56-4.383 3.347zm8.379-8.442a23.6 23.6 0 0 0 1.274-4.495l.225-.137c.374-.238 1.036-.487 1.323-.325.2.113.312.5.312 1.087-.012 2.222-1.86 3.458-3.122 3.87z"
            }
          ),
          /* @__PURE__ */ c.jsx(
            "path",
            {
              fill: "#9CA9FF",
              d: "M24.043 17.4c5.131 0 9.29-2.388 9.29-5.333 0-2.944-4.159-5.332-9.29-5.332s-9.29 2.388-9.29 5.332 4.16 5.332 9.29 5.332"
            }
          )
        ]
      }
    )
  }
));
i.displayName = "HairBaldSpotsIcon";
export {
  i as HairBaldSpotsIcon,
  i as default
};
//# sourceMappingURL=index.js.map
